//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'goodsDetailInfo',
  props: {
    initShow: {
      type: Boolean,
      default: true
    },
    chargeList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      detailShow: this.initShow
    }
  },
  methods: {
    handleDetailShow () {
      this.detailShow = !this.detailShow
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/invoice-detail/goodsDetailInfo.vue